/**
 * @file - File contains all the pixel script constants
 */

export const scripts: any = {
    'adlib-complete': `//pixel.mathtag.com/event/js?mt_id=1486890&mt_adid=234643&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,

    adlib: `//pixel.mathtag.com/event/js?mt_id=1467316&mt_adid=234643&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,

    'fb-complete-registration-us': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
     fbq('init', '998086440340897');
    fbq('track', 'PageView');
    fbq('track', 'CompleteRegistration', {
    value: 1.00,
    currency: 'USD'
    });`,

    'fb-complete-registration-canada': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
     fbq('init', '2780318838961422');
    fbq('track', 'PageView');
    fbq('track', 'CompleteRegistration', {
    value: 1.00,
    currency: 'CAD'
    });`,

    'fb-complete-us': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
     fbq('init', '998086440340897');
    fbq('track', 'PageView');
    fbq('track', 'AddPaymentInfo');`,

    'fb-complete-canada': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
     fbq('init', '2780318838961422');
    fbq('track', 'PageView');
    fbq('track', 'AddPaymentInfo');`,

    'fb-us': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '998086440340897');
    fbq('track', 'PageView')`,

    'fb-image-us': `https://www.facebook.com/tr?id=998086440340897&ev=PageView&noscript=1`,

    'fb-canada': `!function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
    n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t,s)}(window,document,'script',
    'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '2780318838961422');
    fbq('track', 'PageView')`,

    'fb-image-canada': `https://www.facebook.com/tr?id=2780318838961422&ev=PageView&noscript=1`,

    'gridwise-complete': `EF.conversion({
        aid: 11,
    });`,

    'gridwise-script-path': `https://www.gridwisetrack.com/scripts/sdk/everflow.js`,

    'gridwise-script': `EF.click({
        offer_id: EF.urlParameter('oid'),
        affiliate_id: EF.urlParameter('affid'),
        sub1: EF.urlParameter('sub1'),
        sub2: EF.urlParameter('sub2'),
        sub3: EF.urlParameter('sub3'),
        sub4: EF.urlParameter('sub4'),
        sub5: EF.urlParameter('sub5'),
        uid: EF.urlParameter('uid'),
        transaction_id: EF.urlParameter('click_id'),
    });`,

    'RideShareAcquisition-2022-CompletePage': `//pixel.mathtag.com/event/js?mt_id=1579985&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-InfoPage': `//pixel.mathtag.com/event/js?mt_id=1579749&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-JoinPage': `//pixel.mathtag.com/event/js?mt_id=1579747&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-PasswordPage': `//pixel.mathtag.com/event/js?mt_id=1579748&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-PaymentPage': `//pixel.mathtag.com/event/js?mt_id=1579750&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-ProfilePage': `//pixel.mathtag.com/event/js?mt_id=1579984&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,
    'RideShareAcquisition-2022-ProofOfRidesPage': `//pixel.mathtag.com/event/js?mt_id=1579751&mt_adid=248287&mt_exem=&mt_excl=&v1=&v2=&v3=&s1=&s2=&s3=`,

    'tiktok-base': `!function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
    ttq.load('CFN9CTBC77U110MKMQQG');
    ttq.page();
    }(window, document, 'ttq');
    `,

    'at-universal': `var a_id = 10431;
    var p_url = encodeURIComponent(window.location.href);
    var uqNum = Math.random() * 10000000000000;
    var i = document.createElement('img');
    var px = 'https://px.adentifi.com/Pixels?a_id=' + a_id + ';p_url=' + p_url +';uq=' +uqNum;
    i.setAttribute('src', px);
    i.setAttribute('height','1');
    i.setAttribute('width','1');
    i.setAttribute('style','display:none');
    document.body.appendChild(i);`,

    'blis-completed': `window.BLIS_PIXEL_PROPERTIES = {
    baseUrl: "tr.blismedia.com/v1/blis-site-pixel",
    pixelId: "e7242905-800f-464c-ab56-25b45324e95c",
    delay: 5000
    };
    (function(){
    var pixelScript = document.createElement("script");
    pixelScript.src = "https://sitepixel.blis.com/BlisEvent.js";
    pixelScript.async = true;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(pixelScript, s);
    })();`,

    'blis-completed-image': `https://tr.blismedia.com/v1/blis-site-pixel?spid=e7242905-800f-464c-ab56-25b45324e95c&spt=2&a=BLIS_PIXEL_PRIMARY`,

    'blis-join': `window.BLIS_PIXEL_PROPERTIES = {
    baseUrl: "tr.blismedia.com/v1/blis-site-pixel",
    pixelId: "2d5a5ad0-fc6f-4c78-8ffb-2333ce0afd6c",
    delay: 5000
    };
    (function(){
    var pixelScript = document.createElement("script");
    pixelScript.src = "https://sitepixel.blis.com/BlisEvent.js";
    pixelScript.async = true;
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(pixelScript, s);
    })();`,

    'blis-join-image': `https://tr.blismedia.com/v1/blis-site-pixel?spid=2d5a5ad0-fc6f-4c78-8ffb-2333ce0afd6c&spt=2&a=BLIS_PIXEL_PRIMARY`,
};
